import React from 'react'
import Manager from '../../public/components/Manager'
import SupplierChangeApplyDetail from './SupplierChangeApplyDetail'
import SelectChangeSupplierDiv from './SelectChangeSupplierDiv'
Ext.require('Ext.Toast')


const config = {
    tabs: {
        申请中: {
            buttons: [
                {
                    icon: 'plus', text: '添加...', handler: ({ showDetail, refreshPage }) =>
                        Tyan.pubForm.showDialog('选择供应商', props => <SelectChangeSupplierDiv {...props} id={0} onSave={refreshPage} showDetail={showDetail} />)
                }
            ],
            columns: [
                { _text: '供应商信息修改申请单号', field: 'Number', search: true, minWidth: 200/* , tools: tipTools */ },
                { _text: '供应商编号', field: 'Supplier.Number', search: true, minWidth: 150, flex: 1, },
                { _text: '供应商名称', field: 'Supplier.SupplierName', search: true, minWidth: 150, flex: 1, },
                { _text: '申请人', field: 'Creator', minWidth: 150, flex: 1, },
                { _datetime: '申请时间', field: 'CreateTime', minWidth: 150, flex: 1, },
            ],
            onDoubleTap: ({ showDetail }, data) => showDetail(props => <SupplierChangeApplyDetail {...props} id={data.id} />),
        },
        被退回: {
            buttons: [
            ],
            columns: [
                { _text: '供应商信息修改申请单号', field: 'Number', search: true, minWidth: 200/* , tools: tipTools */ },
                { _text: '供应商编号', field: 'Supplier.Number', search: true, minWidth: 150, flex: 1, },
                { _text: '供应商名称', field: 'Supplier.SupplierName', search: true, minWidth: 150, flex: 1, },
                { _text: '申请人', field: 'Creator', minWidth: 150, flex: 1, },
                { _datetime: '申请时间', field: 'CreateTime', minWidth: 150, flex: 1, },
                { _text: '退回原因', field: 'Creator', minWidth: 150, flex: 1, },
            ],
            onDoubleTap: ({ showDetail }, data) => showDetail(props => <SupplierChangeApplyDetail {...props} id={data.id} taskName="供应商信息修改退回申请" />),
        },
        已完成: {
            buttons: [
            ],
            columns: [
                { _text: '供应商信息修改申请单号', field: 'Number', search: true, minWidth: 200/* , tools: tipTools */ },
                { _text: '供应商编号', field: 'Supplier.Number', search: true, minWidth: 150, flex: 1, },
                { _text: '供应商名称', field: 'Supplier.SupplierName', search: true, minWidth: 150, flex: 1, },
                { _text: '申请人', field: 'Creator', minWidth: 150, flex: 1, },
                { _datetime: '申请时间', field: 'CreateTime', minWidth: 150, flex: 1, },
            ],
            onDoubleTap: ({ showDetail }, data) => showDetail(props => <SupplierChangeApplyDetail {...props} id={data.id} />),
        },
    }
}

export default props => <Manager {...props} config={config} />